import React, { useState, useRef } from "react";

import {
  Box, InputAdornment, Grid,
  Avatar,
  Typography,
  MobileStepper,
  TextField,
  Select,
  MenuItem,
  IconButton,
  iconList,
  Button,
} from "@mui/material";
import ProjectHeaderLogo from "assets/images/Group 1171275838.svg";
import ProjectImage from "assets/images/NotebookImage.svg";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { FaRegCalendarAlt } from "react-icons/fa";
import { state } from "utils/statesData";


const SecondStep = ({ formik, handleClick, handlePrevious, activeStep, steps, }) => {
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  const handleStartIconClick = (e) => {
    e.stopPropagation();
    if (startDateRef.current) {
      startDateRef.current.showPicker?.();
      startDateRef.current.focus();
    }
  };

  const handleEndIconClick = (e) => {
    e.stopPropagation();
    if (endDateRef.current) {
      endDateRef.current.showPicker?.();
      endDateRef.current.focus();
    }
  };


  // const state = [
  //   "Andhra Pradesh",
  //   "Arunachal Pradesh",
  //   "Assam",
  //   "Bihar",
  //   "Chhattisgarh",
  //   "Goa",
  //   "Gujarat",
  //   "Haryana",
  //   "Himachal Pradesh",
  //   "Jharkhand",
  //   "Karnataka",
  //   "Kerala",
  //   "Madhya Pradesh",
  //   "Maharashtra",
  //   "Manipur",
  //   "Meghalaya",
  //   "Mizoram",
  //   "Nagaland",
  //   "Odisha",
  //   "Punjab",
  //   "Rajasthan",
  //   "Sikkim",
  //   "Tamil Nadu",
  //   "Telangana",
  //   "Tripura",
  //   "Uttar Pradesh",
  //   "Uttarakhand",
  //   "West Bengal",
  //   // Union Territories
  //   "Andaman and Nicobar Islands",
  //   "Chandigarh",
  //   "Dadra and Nagar Haveli and Daman and Diu",
  //   "Delhi",
  //   "Jammu and Kashmir",
  //   "Ladakh",
  //   "Lakshadweep",
  //   "Puducherry"
  // ];

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f3f3f3",
          minHeight: "100vh",
          p: { xs: "24px 16px", sm: "40px 24px", md: "80px 0px 0px 132px" },
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "flex-end" },
            gap: { xs: 5, sm: 6, md: 8, lg: "326px" },
            width: "100%",
            maxWidth: "100%",
            p: { xs: 0, sm: 0, md: "7px 132px 21px 0px" },
            boxSizing: "border-box",
          }}
        >
          {/* Left Section */}
          <Box
            sx={{
              flex: 1,
              width: { xs: "100%", sm: "100%", md: "525px" },
              maxWidth: "525px",
              display: "flex",
              flexDirection: "column",
              boxSizing: "border-box",

            }}
          >
            {/* Logo */}
            <Avatar
              src={ProjectHeaderLogo}
              sx={{
                width: { xs: 50, sm: 60, md: 60 },
                height: { xs: 50, sm: 60, md: 60 },
                bgcolor: "transparent",
                "& img": {
                  objectFit: "contain",
                  width: "100%",
                  height: "100%",
                },
              }}
            />

            <Box sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: "13px",
              width: "100%",
            }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "flex-start", width: "100%", p: 0 }}>
                <Typography
                  sx={{
                    mt: "0px",
                    fontWeight: 700,
                    fontSize: { xs: "28px", sm: "32px", md: "36px" },
                    lineHeight: 1.1,
                    fontFamily: "Outfit, sans-serif",
                    color: "#252C32",
                  }}
                >
                  Project details
                </Typography>

                {/* Stepper */}
                <MobileStepper
                  variant="progress"
                  steps={steps}
                  position="relative"
                  activeStep={activeStep}
                  sx={{
                    width: { xs: "110%", sm: "110%", md: "105%" },
                    mt: 0,
                    p: 0,
                    background: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "& .MuiMobileStepper-progress": {
                      flexGrow: 1,
                      width: "100%",
                    },
                    "& .MuiLinearProgress-root": {
                      width: "100%",
                      backgroundColor: "#E9E9E9",
                      height: 4,
                      borderRadius: "4px",
                    },
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#143DF2",
                    },
                  }}
                />

              </Box>
              <Typography sx={{
                fontSize: "18px",
                fontWeight: 500,
                color: "#9B9C9F",
                letterSpacing: "0px",
                fontFamily: "Outfit"
              }}>
                2/4
              </Typography>
            </Box>

            {/* Description Texts */}
            <Box
              sx={{
                mt: "15px",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: 1.3,
                  fontFamily: "Outfit, sans-serif",
                  color: "#5B5772",
                }}
              >
                Explore what’s possible when you collaborate with your team. Edit
                project details anytime in project settings.
              </Typography>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: 1.3,
                  fontFamily: "Outfit, sans-serif",
                  color: "#5B5772",
                }}
              >
                Required fields are marked with an asterisk{" "}
                <Box component="span" sx={{ color: "#D92D20" }}>
                  *
                </Box>
              </Typography>
            </Box>

            {/* Form Fields */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", mt: "30px" }}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    fontFamily: "Outfit, sans-serif",
                    color: "#5F5F5F",
                  }}
                >
                  Project Description{" "}
                  <Box component="span" sx={{ color: "#D92D20" }}>
                    *
                  </Box>
                </Typography>
                <TextField
                  placeholder="Project Description"
                  fullWidth
                  multiline
                  minRows={4}
                  variant="standard"
                  InputProps={{
                    disableUnderline: true,
                  }}
                  sx={{
                    mt: "15px",
                    "& .MuiInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "#FFFFFF",
                      px: 2,
                      py: 1,
                      display: "flex",
                      alignItems: "flex-start",
                    },
                    "& .MuiInput-input": {
                      fontFamily: "Outfit, sans-serif",
                      color: "#0A0A0C",
                      textAlign: "start",
                      padding: 0,
                      "&:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        WebkitTextFillColor: "#0A0A0C !important",
                      },
                      "&:-webkit-autofill:hover": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                      },
                      "&:-webkit-autofill:focus": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                      },
                    },
                  }}
                  name="discription"
                  value={formik.values.discription}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.discription && Boolean(formik.errors.discription)}
                  helperText={formik.touched.discription && formik.errors.discription}
                />
              </Box>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", mt: "15px" }} >
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "Outfit, sans-serif",
                  color: "#5F5F5F",
                }}
              >
                Project Timeline
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                <Box sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { md: "flex-start", xs: "flex-start" },
                  gap: "5px",
                  width: "100%"
                }}>

                  <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}>
                    <Box sx={{ position: "relative", display: "inline-block" }}>
                      <TextField
                        type="text"
                        name="start_date"
                        placeholder="Start Date"
                        value={
                          formik.values.start_date
                            ? dayjs(formik.values.start_date).format("DD MMM, YYYY")
                            : ""
                        }
                        readOnly
                        onBlur={formik.handleBlur}
                        error={formik.touched.start_date && Boolean(formik.errors.start_date)}
                        sx={{
                          width: "auto",
                          fontWeight: 400,
                          fontSize: "14px",
                          lineHeight: "100%",
                          letterSpacing: "0.16px",
                          color: "#433F5E",
                          fontFamily: "Outfit, sans-serif",
                          "& .MuiInputBase-input": {
                            cursor: "default",
                          },
                          "& input::-webkit-calendar-picker-indicator": {
                            display: "none",
                          },
                          "& input[type='text']": {
                            appearance: "none",
                            WebkitAppearance: "none",
                            paddingRight: "6px",
                          },
                        }}
                        InputProps={{
                          readOnly: true,
                          startAdornment: (
                            <Box
                              sx={{
                                ml: "0px",
                                mr: 1,
                                color: "#433F5E",
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                position: "relative",
                              }}
                              onClick={handleStartIconClick}
                            >
                              <FaRegCalendarAlt style={{ fontSize: "16px" }} />
                              <input
                                ref={startDateRef}
                                type="date"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  opacity: 0,
                                  width: "100%",
                                  height: "100%",
                                  cursor: "pointer",
                                }}
                                onChange={(e) => {
                                  const selectedDate = e.target.value
                                    ? dayjs(e.target.value).format("YYYY-MM-DD")
                                    : "";
                                  formik.setFieldValue("start_date", selectedDate);
                                }}
                              />
                            </Box>
                          ),
                          sx: {
                            backgroundColor: "#E7E7EB",
                            height: "34px",
                            width: { xs: "100%", md: "145px" },
                            fontSize: "14px",
                            lineHeight: "100%",
                            fontWeight: 600,
                            letterSpacing: "0",
                            color: "#433F5E",
                            fontFamily: "Outfit, sans-serif",
                            borderRadius: "5px",
                            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                            "&:hover .MuiOutlinedInput-notchedOutline": { border: "none !important" },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none !important" },
                          },
                        }}
                      />
                    </Box>
                    {formik.touched.start_date && formik.errors.start_date && (
                      <Typography
                        sx={{
                          color: "#d32f2f",
                          fontSize: "12px",
                          fontFamily: "Outfit, sans-serif",
                          marginTop: "4px",
                          marginLeft: "2px",
                          lineHeight: "1.2"
                        }}
                      >
                        {formik.errors.start_date}
                      </Typography>
                    )}
                  </Box>

                  <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "34px",
                    alignSelf: "flex-start"
                  }}>
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "16px",
                        fontFamily: "Outfit, sans-serif",
                        lineHeight: "100%",
                        color: "#5F5F5FB2",
                      }}
                    >
                      to
                    </Typography>
                  </Box>

                  <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}>
                    <Box sx={{ position: "relative", display: "inline-block" }}>
                      <TextField
                        type="text"
                        name="end_date"
                        placeholder="End Date"
                        value={
                          formik.values.end_date
                            ? dayjs(formik.values.end_date).format("DD MMM, YYYY")
                            : ""
                        }
                        readOnly
                        onBlur={formik.handleBlur}
                        error={formik.touched.end_date && Boolean(formik.errors.end_date)}
                        sx={{
                          width: "auto",
                          fontWeight: 400,
                          fontSize: "14px",
                          lineHeight: "100%",
                          letterSpacing: "0.16px",
                          color: "#433F5E",
                          fontFamily: "Outfit, sans-serif",
                          "& .MuiInputBase-input": {
                            cursor: "default",
                          },
                          "& input::-webkit-calendar-picker-indicator": {
                            display: "none",
                          },
                          "& input[type='text']": {
                            appearance: "none",
                            WebkitAppearance: "none",
                            paddingRight: "6px",
                          },
                        }}
                        InputProps={{
                          readOnly: true,
                          startAdornment: (
                            <Box
                              sx={{
                                ml: "0px",
                                mr: 1,
                                color: "#433F5E",
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                position: "relative",
                              }}
                              onClick={handleEndIconClick}
                            >
                              <FaRegCalendarAlt style={{ fontSize: "16px" }} />
                              <input
                                ref={endDateRef}
                                type="date"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  opacity: 0,
                                  width: "100%",
                                  height: "100%",
                                  cursor: "pointer",
                                }}
                                onChange={(e) => {
                                  const selectedDate = e.target.value
                                    ? dayjs(e.target.value).format("YYYY-MM-DD")
                                    : "";
                                  formik.setFieldValue("end_date", selectedDate);
                                }}
                              />
                            </Box>
                          ),
                          sx: {
                            backgroundColor: "#E7E7EB",
                            height: "34px",
                            width: { xs: "100%", md: "145px" },
                            fontSize: "14px",
                            lineHeight: "100%",
                            fontWeight: 600,
                            letterSpacing: "0",
                            color: "#433F5E",
                            fontFamily: "Outfit, sans-serif",
                            borderRadius: "5px",
                            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                            "&:hover .MuiOutlinedInput-notchedOutline": { border: "none !important" },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none !important" },
                          },
                        }}
                      />
                    </Box>
                    {formik.touched.end_date && formik.errors.end_date && (
                      <Typography
                        sx={{
                          color: "#d32f2f",
                          fontSize: "12px",
                          fontFamily: "Outfit, sans-serif",
                          marginTop: "4px",
                          marginLeft: "2px",
                          lineHeight: "1.2"
                        }}
                      >
                        {formik.errors.end_date}
                      </Typography>
                    )}
                  </Box>

                </Box>
              </Box>
            </Box>

            {/* Project Type */}
            <Box sx={{ mt: "15px" }}>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "Outfit, sans-serif",
                  color: "#5F5F5F",
                }}
              >
                Project Address{" "}
                <Box component="span" sx={{ color: "#D92D20" }}>
                  *
                </Box>
                <Grid container rowSpacing={1.4} columnSpacing={1}>
                  <Grid size={12}>
                    <TextField
                      placeholder="Address Line 1"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      sx={{
                        mt: "9px",
                        "& .MuiInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "#FFFFFF",
                          height: 48,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiInput-input": {
                          fontFamily: "Outfit, sans-serif",
                          padding: 0,
                          color: "#0A0A0C",
                          "&:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                            WebkitTextFillColor: "#0A0A0C !important",
                          },
                          "&:-webkit-autofill:hover": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          },
                          "&:-webkit-autofill:focus": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          },
                        },
                      }}
                      name="address_line_1"
                      value={formik.values.address_line_1}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.address_line_1 && Boolean(formik.errors.address_line_1)}
                      helperText={formik.touched.address_line_1 && formik.errors.address_line_1}
                    />
                  </Grid>

                  <Grid size={6}>
                    <Select

                      displayEmpty
                      fullWidth
                      sx={{
                        height: 44,
                        backgroundColor: "#FFFFFF",
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #ECECEC",
                        },
                        "& .MuiSelect-select": {
                          px: 2,
                          fontSize: 16,
                          fontWeight: 400,
                          fontFamily: "Outfit, sans-serif",
                          color: "#3F3F3F",
                          "&:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                            WebkitTextFillColor: "#3F3F3F !important",
                          },
                        },
                      }}
                      name="state"
                      value={formik.values.state}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.state && Boolean(formik.errors.state)}
                      helperText={formik.touched.state && formik.errors.state}
                    >
                      <MenuItem value="" disabled>
                        State
                      </MenuItem>
                      {state.map((type, index) => (
                        <MenuItem key={index} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid size={6}>
                    <TextField
                      placeholder="City"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      sx={{

                        "& .MuiInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "#FFFFFF",
                          height: 44,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiInput-input": {
                          fontFamily: "Outfit, sans-serif",
                          padding: 0,
                          color: "#0A0A0C",
                          "&:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                            WebkitTextFillColor: "#0A0A0C !important",
                          },
                          "&:-webkit-autofill:hover": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          },
                          "&:-webkit-autofill:focus": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          },
                        },
                      }}
                      name="city"
                      value={formik.values.city}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.city && Boolean(formik.errors.city)}
                      helperText={formik.touched.city && formik.errors.city}
                    />
                  </Grid>
                  <Grid size={6}>
                    <TextField
                      placeholder="country"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        disableUnderline: true,
                        readOnly: true
                      }}
                      sx={{

                        "& .MuiInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "#FFFFFF",
                          height: 44,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiInput-input": {
                          fontFamily: "Outfit, sans-serif",
                          padding: 0,
                          color: "#0A0A0C",
                          "&:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                            WebkitTextFillColor: "#0A0A0C !important",
                          },
                          "&:-webkit-autofill:hover": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          },
                          "&:-webkit-autofill:focus": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          },
                        },
                      }}
                      name="country"
                      value={formik.values.country}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.country && Boolean(formik.errors.country)}
                      helperText={formik.touched.country && formik.errors.country}
                    />

                  </Grid>

                  <Grid size={6}>
                    <TextField
                      placeholder="zipcode"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      sx={{

                        "& .MuiInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "#FFFFFF",
                          height: 44,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiInput-input": {
                          fontFamily: "Outfit, sans-serif",
                          padding: 0,
                          color: "#0A0A0C",
                          "&:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                            WebkitTextFillColor: "#0A0A0C !important",
                          },
                          "&:-webkit-autofill:hover": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          },
                          "&:-webkit-autofill:focus": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          },
                        },
                      }}
                      name="zipcode"
                      value={formik.values.zipcode}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.zipcode && Boolean(formik.errors.zipcode)}
                      helperText={formik.touched.zipcode && formik.errors.zipcode}
                    />

                  </Grid>
                </Grid>

              </Typography>

            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", mt: "15px" }} >
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "Outfit, sans-serif",
                  color: "#5F5F5F",
                }}
              >
                Geo Location
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: "5px" }}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <TextField
                      placeholder="Latitude"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        width: "145px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "#E7E7EB",
                          height: "34px",
                          border: "none",
                          "& input:-webkit-autofill": {
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "#433F5E !important",
                            caretColor: "#433F5E",
                            transition: "background-color 5000s ease-in-out 0s",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          textAlign: "center",
                          color: "#433F5E",
                          fontFamily: "Outfit, sans-serif",
                          fontSize: "14px",
                          fontWeight: 600,
                          lineHeight: "100%",
                          "&:-webkit-autofill": {
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "#433F5E !important",
                          },
                        },
                      }}
                      name="latitude"
                      value={formik.values.latitude}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.latitude && Boolean(formik.errors.latitude)}
                    />
                    {formik.touched.latitude && formik.errors.latitude && (
                      <Typography
                        sx={{
                          color: "#d32f2f",
                          fontSize: "12px",
                          fontFamily: "Outfit, sans-serif",
                          marginTop: "4px",
                          lineHeight: "1.2",
                          width: "145px",
                          textAlign: "center"
                        }}
                      >
                        {formik.errors.latitude}
                      </Typography>
                    )}
                  </Box>

                  <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "34px",
                    alignSelf: "flex-start"
                  }}>
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "16px",
                        fontFamily: "Outfit",
                        lineHeight: "100%",
                        color: "#000000",
                      }}
                    >
                      -
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <TextField
                      placeholder="Longitude"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        width: "145px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "#E7E7EB",
                          height: "34px",
                          border: "none",
                          "& input:-webkit-autofill": {
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "#433F5E !important",
                            caretColor: "#433F5E",
                            transition: "background-color 5000s ease-in-out 0s",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          textAlign: "center",
                          color: "#433F5E",
                          fontFamily: "Outfit, sans-serif",
                          fontSize: "14px",
                          fontWeight: 600,
                          lineHeight: "100%",
                          "&:-webkit-autofill": {
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "#433F5E !important",
                          },
                        },
                      }}
                      name="longitude"
                      value={formik.values.longitude}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.longitude && Boolean(formik.errors.longitude)}
                    />
                    {formik.touched.longitude && formik.errors.longitude && (
                      <Typography
                        sx={{
                          color: "#d32f2f",
                          fontSize: "12px",
                          fontFamily: "Outfit, sans-serif",
                          marginTop: "4px",
                          lineHeight: "1.2",
                          width: "145px",
                          textAlign: "center"
                        }}
                      >
                        {formik.errors.longitude}
                      </Typography>
                    )}
                  </Box>

                </Box>
              </Box>
            </Box>
            <Box sx={{
              mt: "20px",
              display: "flex",
              alignItems: "center",
              gap: "40px"
            }}>

              <Box sx={{
                width: "230px",
                height: "48px",
                borderRadius: "3px",
                backgroundColor: "#00344C",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
                <Button
                  onClick={handleClick}
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    lineHeight: "16px",
                    letterSpacing: "1%",
                    color: "#FFFFFF",
                    width: "100%",
                    height: "100%",
                    textTransform: "none",
                    fontFamily: "Outfit, sans-serif"
                  }}>
                  Continue
                </Button>
              </Box>
              <Button
                onClick={handlePrevious}
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "12px",
                  color: "#143DF2",
                  textTransform: "none",
                  letterSpacing: "0%",
                  textDecoration: "underline",
                  p: 0,
                  minWidth: "auto",
                  fontFamily: "Outfit, sans-serif"
                }}
              >
                Previous step
              </Button>
            </Box>

          </Box>

          {/* Right Section (Image) */}
          <Box
            sx={{
              flexShrink: 0,
              width: { xs: "90%", md: "240px", lg: "327px" },
              height: { xs: "250px", md: "270px", lg: "350px" },
              border: "1px solid #ECECEC",
              borderRadius: "3px",
              bgcolor: "#FFFFFF",
              display: "flex",
              flexDirection: "column",
              mt: { xs: 4, md: 0 },
              p: "30px",
              alignSelf: { xs: "center", md: "center" },
            }}
          >
            <Box sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",

            }}>
              <Box
                component="img"
                src={ProjectImage}
                alt="Project preview"
                sx={{
                  width: { sm: "200px", md: "238px" },
                  height: "200",
                  objectFit: "contain",
                }}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", mt: "18px", gap: "16px" }}>
              <Typography sx={{ fontSize: "16px", fontWeight: "600", lineHeight: "100%", color: "#3F3F3F", fontFamily: "Outfit, sans-serif" }}>
                Manage EPC Project
              </Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "100%", color: "#3F3F3F", fontFamily: "Outfit, sans-serif" }}>
                Manage design projects effectively, visualize tasks, and see team workload
              </Typography>
            </Box>

          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SecondStep;
